module.exports = __webpack_public_path__ + "img/logo.df86b942.png";